import React, { useEffect, useRef } from 'react'
import { useTranslation } from 'next-i18next'

const TiqetsBookingEngine = ({ productId }: { productId: string }) => {
  const { i18n } = useTranslation('common')
  const partner = 'sight2sight'
  const language = i18n.language as AppLocale
  const containerRef = useRef(null)
  const scriptRef = useRef(null)

  useEffect(() => {
    if (scriptRef.current) {
      scriptRef.current.remove()
    }

    const widget = document.createElement('div')
    widget.setAttribute('data-tiqets-widget', 'availability')
    widget.setAttribute('data-layout', 'compact')
    widget.setAttribute('data-orientation', 'vertical')
    widget.setAttribute('data-product-id', productId)
    widget.setAttribute('data-partner', partner)
    widget.setAttribute('data-language', language)
    widget.className = 'flex flex-col items-center'

    if (containerRef.current) {
      containerRef.current.innerHTML = ''
      containerRef.current.appendChild(widget)
    }

    const script = document.createElement('script')
    script.src = 'https://widgets.tiqets.com/loader.js'
    script.defer = true
    script.async = true
    script.onload = () => {
      console.log('Tiqets loader script loaded successfully')
    }
    script.onerror = (error) => {
      console.error('Error loading Tiqets script:', error)
    }

    document.body.appendChild(script)
    scriptRef.current = script

    return () => {
      if (scriptRef.current) {
        scriptRef.current.remove()
      }
    }
  }, [productId, partner, language])

  return <div ref={containerRef} className="w-full flex justify-center" />
}

export default TiqetsBookingEngine
